var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-sheet",
    {
      staticClass:
        "rounded-xl footer pa-6 pb-2 d-flex flex-column justify-space-between height-100x",
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "mb-6 mb-md-0", attrs: { cols: "12", md: "2" } },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-center justify-md-start" },
                [
                  _c(
                    "v-avatar",
                    { attrs: { tile: "", width: "120", height: "auto" } },
                    [
                      _c("v-img", {
                        attrs: {
                          contain: "",
                          src: require("@/assets/logos/full_logo_horizontal_grey.svg"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "mb-6 mb-md-0 text-center text-sm-left",
              attrs: { cols: "12", sm: "6", md: "3" },
            },
            [
              _c("div", { staticClass: "text-overline-h6" }, [
                _vm._v(_vm._s(_vm.$t("Footer.company.title"))),
              ]),
              _c("div", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("Footer.company.name")))]),
                _c("br"),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("Footer.company.ceoLabel"))),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("Footer.company.ceoName"))),
                _c("br"),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("Footer.company.businessRegLabel"))),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("Footer.company.businessRegNo"))),
                _c("br"),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("Footer.company.mailOrderLabel"))),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("Footer.company.mailOrderValue"))),
                _c("br"),
              ]),
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "mb-6 mb-md-0 text-center text-sm-left",
              attrs: { cols: "12", sm: "6", md: "5" },
            },
            [
              _c("div", { staticClass: "text-overline-h6" }, [
                _vm._v(_vm._s(_vm.$t("Footer.contact.title"))),
              ]),
              _c("div", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("Footer.contact.addressLabel"))),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("Footer.contact.addressValue"))),
                _c("br"),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("Footer.contact.telLabel"))),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("Footer.contact.telValue"))),
                _c("br"),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("Footer.contact.emailLabel"))),
                ]),
                _c(
                  "a",
                  {
                    staticClass: "footer-link",
                    attrs: { href: "mailto:ghkang@foex.kr" },
                  },
                  [_vm._v("ghkang@foex.kr")]
                ),
                _c("br"),
              ]),
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "text-center text-md-left",
              attrs: { cols: "12", sm: "12", md: "2" },
            },
            [
              _c("div", { staticClass: "text-overline-h6" }, [
                _vm._v(_vm._s(_vm.$t("Footer.links.title"))),
              ]),
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "footer-link",
                      attrs: {
                        to: { name: "refund-policy-en" },
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Footer.links.refundPolicyEn")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "footer-link",
                      attrs: {
                        to: { name: "refund-policy-kr" },
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Footer.links.refundPolicyKr")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "end", "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-divider", { staticClass: "mb-2" }),
              _c("div", { staticClass: "text-center caption" }, [
                _vm._v(
                  _vm._s(_vm.$t("Footer.copyright", { year: _vm.currentYear }))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }